export default {
  nome: 'Nome',
  cbo: 'CBO',
  tabela: {
    nome: 'Nome',
    cbo: 'CBO'
  },
  titulo_modal: 'Cargos',
};
